import { useCallback, useEffect, useState } from "react";
import { PLATFORM_NOTIFICATIONS_REFRESH_EVENT } from "../constants/platformNotification";

export function useDashboardTabNotificationCounts({ enabled, fetchCounts, refreshOnPathChange = true, pathname = "" }) {
  const [tabCounts, setTabCounts] = useState({});

  const loadTabCounts = useCallback(async () => {
    if (!enabled) return;
    try {
      const res = await fetchCounts();
      setTabCounts(res?.data ?? res ?? {});
    } catch {
      setTabCounts({});
    }
  }, [enabled, fetchCounts]);

  useEffect(() => {
    void loadTabCounts();
  }, [loadTabCounts, refreshOnPathChange ? pathname : null]);

  useEffect(() => {
    const refresh = () => void loadTabCounts();
    window.addEventListener(PLATFORM_NOTIFICATIONS_REFRESH_EVENT, refresh);
    return () => window.removeEventListener(PLATFORM_NOTIFICATIONS_REFRESH_EVENT, refresh);
  }, [loadTabCounts]);

  return tabCounts;
}
